"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeLicensesClient = void 0;
class FakeLicensesClient {
    constructor() {
        this.licenses = [];
        this.embeds = {};
        this.downloadUrls = {};
        this.transcripts = {};
        this.metadata = {};
        this.captions = {};
    }
    clear() {
        this.licenses = [];
        this.embeds = {};
        this.downloadUrls = {};
        this.transcripts = {};
    }
    insert(license) {
        this.licenses.push(license);
    }
    insertEmbedForVideo(embed, videoId) {
        this.embeds[videoId] = embed;
    }
    insertDownloadUrl(downloadUrl, videoId) {
        this.downloadUrls[videoId] = downloadUrl;
    }
    insertTranscript(transcript, videoId) {
        this.transcripts[videoId] = transcript;
    }
    insertMetadataForVideo(id, metadata) {
        this.metadata[id] = metadata;
    }
    insertCaptionForVideo(id, caption) {
        this.captions[id] = caption;
    }
    getUserLicensedContent(page, size) {
        const nonNullablePage = page || 0;
        const nonNullableSize = size || 10;
        const startIndex = nonNullablePage * nonNullableSize;
        const endIndex = startIndex + nonNullableSize;
        return Promise.resolve({
            page: this.licenses.slice(startIndex, endIndex),
            pageSpec: {
                number: nonNullablePage,
                size: nonNullableSize,
                totalElements: this.licenses.length,
                totalPages: Math.ceil(this.licenses.length / nonNullableSize),
            },
        });
    }
    getAccountLicensedContent(page, size) {
        return this.getUserLicensedContent(page, size);
    }
    createEmbedCode(licensedContent, _segmentStart, _segmentEnd) {
        const embed = this.embeds[licensedContent.videoId];
        return embed
            ? Promise.resolve({ embed })
            : Promise.reject("Embed code can't be created!");
    }
    getDownloadVideoUrl(licensedContent) {
        const downloadUrl = this.downloadUrls[licensedContent.videoId];
        return downloadUrl
            ? Promise.resolve(downloadUrl)
            : Promise.reject("Download URL can't be fetched!");
    }
    getTranscript(licensedContent) {
        if (!!this.transcripts[licensedContent.videoId]) {
            return Promise.resolve(this.transcripts[licensedContent.videoId]);
        }
        return Promise.reject("Transcript doesn't exist");
    }
    getMetadata(content) {
        return Promise.resolve({
            content: this.metadata[content.videoId],
            filename: `metadata-${content.videoId}`,
            mimeType: 'text/csv',
        });
    }
    getCaptions(licensedContent) {
        if (!!this.captions[licensedContent.videoId]) {
            return Promise.resolve(this.captions[licensedContent.videoId]);
        }
        return Promise.reject("Captions don't exist");
    }
}
exports.FakeLicensesClient = FakeLicensesClient;
//# sourceMappingURL=FakeLicensesClient.js.map